import store from '@/core/store'
import {actionTypes} from '@/core/constants'

class BuscarProdutoListener {
    async execute() {
        return await store.dispatch(actionTypes.BUSCAR_PRODUTO_POR_NOME)
    }
}

export default new BuscarProdutoListener()
